<template>
    <div class="tag tag--stock-indicator" ref="stockIndicator" @click="togglePanel()" v-click-outside="hidePanel">
        <span>{{ $t("Stockindicatie") }}</span>
        <i v-if="defaultStock && defaultStock.status" class="dot" :class="`dot--stock-${defaultStock.status}`"></i>

        <div class="stock-panel" ref="stockPanel" v-show="showPanel">
            <table>
                <tr v-for="(line, index) in stockLines" :key="index">
                    <td class="uppercase font-bold">{{ line.inventSiteName }}</td>
                    <td><i class="dot" :class="`dot--stock-${line.status}`"></i></td>
                    <td v-if="inSalesApp">{{ line.availPhysical }}</td>
                    <td>
                        <template v-if="!stockStatuses.includes('green') && !stockStatuses.includes('orange') && line.ranDeliveryFrequency !== '5'">
                            {{ deliveryStatus[line.ranDeliveryFrequency] }}
                        </template>
                    </td>
                </tr>
            </table>
            <p><small>{{
                $t("lastUpdated", {
                    date: new Date().toLocaleDateString(['nl-BE'], {month: 'numeric', day: '2-digit', year: 'numeric'}),
                    time: syncTime
                }) }}
            </small></p>
        </div>
    </div>
</template>

<script>
import Vue from "vue"
import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)

export default {
    name: "StockModal",

    props: {
        inSalesApp: {
            type: Boolean,
            default: false,
        },
        stockLinesArray: {
            type: Array,
            default: function () { return []; }
        },
        stockLinesJson: {
            type: Object,
            default: function () { return {}; }
        },
        syncTime: {
            type: String,
            default: false
        }
    },

    data() {
        return {
            showPanel: false,
            defaultStock: {},
            stockLines: [],
            deliveryStatus: {
                '0': window.i18n.t('Undefined'),
                '10': window.i18n.t('Weekly'),
                '20': window.i18n.t('Biweekly'),
                '30': window.i18n.t('Monthly'),
                '40': window.i18n.t('More than one month'),
                '50': window.i18n.t('While stock last')
            },
            stockStatuses: []
        }
    },

    mounted() {
        document.addEventListener('scroll', this.hidePanel)
        this.stockLines.forEach((line) => {
            if(!this.stockStatuses.includes(line.status)) {
                this.stockStatuses.push(line.status)
            }
        })
    },

    created() {
        if(Object.keys(this.stockLinesJson).length !== 0) {
            this.stockLines = this.stockLinesJson
            this.defaultStock = this.stockLines.shift()
        } else {
            this.stockLines = this.stockLinesArray
            this.defaultStock = this.stockLines.shift()
        }
    },

    methods: {
        togglePanel() {
            const indicator = this.$refs.stockIndicator
            const indicatorPosition = indicator.getBoundingClientRect()
            const panel = this.$refs.stockPanel

            panel.style.setProperty('top', indicatorPosition.top + "px")

            if( window.innerWidth > 768) {
                panel.style.setProperty('left', (indicatorPosition.right - 300) + "px")
            }

            this.showPanel = !this.showPanel
        },

        hidePanel() {
            this.showPanel = false
        }
    }
}
</script>
